import { fetch } from '../utils/request';

const getUrl = (path) => `${process.env.MONO_API}${path}`;

export default {
  /**
   * Fetch the list of Shows for the current business unit.
   * @param {Object} opts
   * @param {Number} [opts.page] - Page number
   * @param {Number} [opts.limit] - Amount of shows to fetch
   * @param {String} [opts.search] - Optional title search term
   */
  getShows(opts = {}) {
    const {
      page = 1,
      limit = 100,
      search = '',
    } = opts;

    return fetch(getUrl('/shows'), {
      query: {
        page,
        limit,
        ...(search ? { search } : {}),
      },
    });
  },

  /**
   * Fetch a single Show with its full resolved item hierarchy.
   * @param {Number} id - ID of the show to fetch.
   */
  getShow(id) {
    return fetch(getUrl(`/shows/${id}`));
  },
};
